export function resolveRewardsLimit(hasLimitValue, limitValue) {
  return hasLimitValue && limitValue > 0 ? limitValue : 5;
}

export function isRewardsNearBottom(scrollHeight, scrollTop, clientHeight, threshold = 12) {
  return scrollHeight - scrollTop - clientHeight <= threshold;
}

export function buildRewardsLoadQuery({ panel, cursor, limit, cursorId }) {
  const query = new URLSearchParams({
    panel,
    cursor,
    limit: String(limit),
  });

  if (cursorId) {
    query.set("cursor_id", cursorId);
  }

  return query;
}
